import request from '@/utils/request'

export default {
    //人才招聘
    index: params => {
        return request({
            url: '/recruit',
            method: 'GET',
            params
        })
    },
    //人才招聘列表
    recruitList: params => {
        return request({
            url: '/recruit/List',
            method: 'POST',
            params
        })
    },
    //人才招聘详情
    recruitDetail: params => {
        return request({
            url: '/recruit/Info',
            method: 'GET',
            params
        })
    },
    recruitfile: params => {
        return request({
            url: '/recruit/sub',
            method: 'POST',
            params
        })
    },
    // 上传简历
    uploadImg: params => {
        return request({
            url: `/recruit/sub`,
            method: 'POST',
            params
        });
    },
    // 获取计算签名(文档)
    getAuthorization(params) {
        return request({
            url: `/txcloud/GetCosAuthorization?type=web`,
            method: 'GET',
            params
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/recruit.js